import Footer from './Footer';

export default Footer;
export * from './Footer';
export * from './types';
